class TruncateText extends HTMLElement {
  static observedAttributes = [];
  constructor() {
  super();
  this.initialSwap();
}

connectedCallback() {
  this.addEventListener('click', this.toggleTruncate.bind(this));
}

disconnectedCallback() {
  this.removeEventListener('click', this.toggleTruncate);
}
attributeChangedCallback() {}

initialSwap() {
  const truncateEnabled = JSON.parse(this.getAttribute('data-truncate'));
  const truncateExpanded = JSON.parse(this.getAttribute('data-truncate-expanded'));

  if (truncateEnabled) {
    if (truncateExpanded) {
      this.innerHTML = this.getAttribute('data-full-description');
    } else {
      this.innerHTML = this.getAttribute('data-truncate-description');
    }
      this.classList.remove("[&[data-truncate='true'][data-truncate-expanded='false']]:line-clamp-(--line-clamp)");
    }
  }

  toggleTruncate() {
    const truncateExpanded = JSON.parse(this.getAttribute('data-truncate-expanded'));
    truncateExpanded ? this.innerHTML = this.getAttribute('data-truncate-description') : this.innerHTML = this.getAttribute('data-full-description');

    this.setAttribute('data-truncate-expanded', !truncateExpanded);
  }
}

customElements.define("truncate-text", TruncateText);